import React, { useEffect, useState } from 'react';
import type { SectionItemConfig } from '../../types/settings';
import { getStaticContent } from '../../api/assets';
import { componentCatalog } from '../../components';

interface SectionItemProps {
  config: SectionItemConfig;
}

/**
 * Resolve um item de seção:
 *
 * - `render: false` oculta;
 * - `file` injeta um HTML estático de `public/assets/<hostname>/content/`;
 * - `component` resolve pelo catálogo em `src/components/index.tsx`.
 *
 * Esses três mecanismos são os ÚNICOS pontos de customização por marca. Não
 * existe condicional de marca dentro de componente.
 */
export function SectionItem({ config }: SectionItemProps) {
  if (config.render === false) {
    return null;
  }

  if (config.file) {
    return <StaticContent file={config.file} />;
  }

  if (config.component) {
    const Component = componentCatalog[config.component];
    if (!Component) {
      console.warn(`Componente "${config.component}" não está registrado no catálogo`);
      return null;
    }
    return <Component variables={config.variables} name={config.name} />;
  }

  return null;
}

function StaticContent({ file }: { file: string }) {
  const [html, setHtml] = useState<string>('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    getStaticContent(file)
      .then((content) => {
        if (!cancelled) setHtml(content);
      })
      .catch((error) => {
        console.error(`Falha ao carregar o conteúdo estático: ${file}`, error);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [file]);

  if (loading) return null;

  return <div dangerouslySetInnerHTML={{ __html: html }} />;
}
